<div class="row thumb-nail-container"
     cdkDropList
     cdkDropListSortingDisabled
     [cdkDropListData]="fileMetaList?.entries"
     [cdkDropListConnectedTo]="[cdkDropListConnectedTo]"
     [cdkDropListDisabled]="disabled"
     (cdkDropListDropped)="fileDropped($event)">
  <select-thumb-nail *ngFor="let file of fileMetaList?.entries; let idx = index"
                     [idPrefix]="(idPrefix + 'item_' + idx)"
                     [file]="file"
                     cdkDrag
                     [cdkDragDisabled]="file.not_selectable"
                     [cdkDragData]="{ file: file, category: category }"
                     [selected]="isSelected(file.id)"
                     (select)="selectFile($event)"
                     [disabled]="disabled">
  </select-thumb-nail>
</div>
